import React, { useEffect, useState,useRef } from "react";
import Layout from './Layout';
import { useNavigate } from "react-router-dom";
import { Eye } from "react-bootstrap-icons"; 
import AxiosInstance from '../AxiosInstance';
import { ArrowLeftCircle,Download } from "react-bootstrap-icons";
import { Button,Row,Col } from "react-bootstrap";
import ToastNotification from "../ToastNotification";
const RemarkFilter = () => {
    const navigate = useNavigate();
    const [remarks, setRemarks] = useState([]);
    const [filters, setFilters] = useState({
        employee_name: "",
        title: "",
        description: "",
        remark_reason: "",
        status_name: "",
        date: "",
        created_at: "",
        from_date: "",  // New from_date filter
        to_date: ""     // New to_date filter
    });
    const toastRef = useRef(null);
    useEffect(() => {
        fetchRemarks();
    }, []); // fetch remarks when component is mounted

    const fetchRemarks = async () => {
        try {
            const response = await AxiosInstance.get("/admin/get-all-remarks"); // Ensure this is correct
            setRemarks(response.data);
        } catch (err) {
             toastRef.current?.showToast("Failed to fetch remarks", "danger");
        }
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({ ...prev, [name]: value }));
    };

    // Function to filter remarks by date range
    const filterByDateRange = (remark) => {
        const { from_date, to_date } = filters;
        const remarkDate = new Date(remark.created_at); // Assuming `created_at` field is available

        if (from_date && new Date(from_date) > remarkDate) return false;
        if (to_date && new Date(to_date) < remarkDate) return false;

        return true;
    };

    const filteredRemarks = remarks.filter((remark) => {
        // Apply date range filter along with other filters
        const isDateInRange = filterByDateRange(remark);
        const isOtherFiltersPassed = Object.entries(filters).every(([key, value]) => {
            if (key === "from_date" || key === "to_date") return true; // Skip date filters for text comparison
            return remark[key]?.toLowerCase().includes(value.toLowerCase());
        });

        return isDateInRange && isOtherFiltersPassed;
    });

    const downloadCSV = () => {
        const headers = [
            "Employee Name",
            "Title",
            "Description",
            "File",
            "Remark Reason",
            "Status",
            "Date",
            "Created At"
        ];
    
        const rows = filteredRemarks.map(remark => [
            remark.employee_name,
            remark.title,
            remark.description,
            remark.file_path ? `${process.env.REACT_APP_BASE_URL}/${remark.file_path}` : "",
            remark.remark_reason,
            remark.status_name,
            new Date(remark.date).toLocaleDateString('en-US'),
            new Date(remark.created_at).toLocaleString()
        ]);
    
        const csvContent = [headers, ...rows].map(row =>
            row.map(field => `"${field}"`).join(",")
        ).join("\n");
    
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
    
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", `remarks_report_${Date.now()}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };    

    return (
        <Layout heading="Remarks List">
            <Row className="mb-3 align-items-center">
                <Col xs={6} className="d-flex justify-content-start">
                    <Button className="btn btn-secondary" onClick={() => navigate(-1)}>
                        <ArrowLeftCircle />
                    </Button>
                </Col>
                <Col xs={6} className="d-flex justify-content-end">
                    <Button
                    className="btn btn-secondary px-3 py-2"
                    style={{ color: "white", minWidth: "auto" }}
                    onClick={downloadCSV}
                    >
                    <Download className="me-2" />
                    .csv
                    </Button>
                </Col>
            </Row>
            <div className="p-3">
                {/* Date range filters */}
                <div className="row mb-3">
                    <div className="col">
                        <label>From Date</label>
                        <input
                            type="date"
                            name="from_date"
                            value={filters.from_date}
                            onChange={handleFilterChange}
                            className="form-control"
                        />
                    </div>
                    <div className="col">
                        <label>To Date</label>
                        <input
                            type="date"
                            name="to_date"
                            value={filters.to_date}
                            onChange={handleFilterChange}
                            className="form-control"
                        />
                    </div>
                </div>
            <div className="table-responsive d-block d-md-none" style={{ maxHeight: "300px", overflowY: "auto" }}>
            <table className="table table-hover text-center align-middle table-striped">
                <thead className="table-primary">
                <tr>
                    <th>Employee</th>
                    <th>Title</th>
                    <th>Description</th>
                    <th>File</th>
                    <th>Reason</th>
                    <th>Status</th>
                    <th>Created</th>
                </tr>
                </thead>
                <tbody>
                {filteredRemarks.length > 0 ? (
                    filteredRemarks.map((remark) => (
                    <tr key={remark.id}>
                        <td>{remark.employee_name}</td>
                        <td>{remark.title}</td>
                        <td>{remark.description}</td>
                        <td>
                        {remark.file_path && (
                            <a
                            href={`${process.env.REACT_APP_BASE_URL}/${remark.file_path}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary"
                            title="View File"
                            >
                            <Eye />
                            </a>
                        )}
                        </td>
                        <td>{remark.remark_reason}</td>
                        <td>{remark.status_name}</td>
                        <td>
                        {new Date(remark.created_at).toLocaleDateString()} <br />
                        {new Date(remark.created_at).toLocaleTimeString()}
                        </td>
                    </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan="7" className="text-muted">No remarks found.</td>
                    </tr>
                )}
                </tbody>
            </table>
            </div>
            <div className="table-responsive d-none d-md-block p-3">
            <table className="table table-hover text-center align-middle table-striped">
                <thead className="table-primary">
                <tr>
                    <th>
                    Employee Name <br />
                    <input
                        type="text"
                        name="employee_name"
                        value={filters.employee_name}
                        onChange={handleFilterChange}
                        className="form-control form-control-sm"
                    />
                    </th>
                    <th>
                    Title <br />
                    <input
                        type="text"
                        name="title"
                        value={filters.title}
                        onChange={handleFilterChange}
                        className="form-control form-control-sm"
                    />
                    </th>
                    <th>
                    Description <br />
                    <input
                        type="text"
                        name="description"
                        value={filters.description}
                        onChange={handleFilterChange}
                        className="form-control form-control-sm"
                    />
                    </th>
                    <th>File</th>
                    <th>
                    Remark Reason <br />
                    <input
                        type="text"
                        name="remark_reason"
                        value={filters.remark_reason}
                        onChange={handleFilterChange}
                        className="form-control form-control-sm"
                    />
                    </th>
                    <th>
                    Status <br />
                    <input
                        type="text"
                        name="status_name"
                        value={filters.status_name}
                        onChange={handleFilterChange}
                        className="form-control form-control-sm"
                    />
                    </th>
                    <th>
                    Created At <br />
                    <input
                        type="text"
                        name="created_at"
                        value={filters.created_at}
                        onChange={handleFilterChange}
                        className="form-control form-control-sm"
                    />
                    </th>
                </tr>
                </thead>
                <tbody>
                {filteredRemarks.length > 0 ? (
                    filteredRemarks.map((remark) => (
                    <tr key={remark.id}>
                        <td>{remark.employee_name}</td>
                        <td>{remark.title}</td>
                        <td>{remark.description}</td>
                        <td className="text-center">
                        {remark.file_path && (
                            <a
                            href={`${process.env.REACT_APP_BASE_URL}/${remark.file_path}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-sm btn-outline-primary"
                            title="View File"
                            >
                            <Eye />
                            </a>
                        )}
                        </td>
                        <td>{remark.remark_reason}</td>
                        <td>{remark.status_name}</td>
                        <td>
                        {new Date(remark.created_at).toLocaleDateString()} <br />
                        {new Date(remark.created_at).toLocaleTimeString()}
                        </td>
                    </tr>
                    ))
                ) : (
                    <tr>
                    <td colSpan="7" className="text-muted">No remarks found.</td>
                    </tr>
                )}
                </tbody>
            </table>
            </div>
            <ToastNotification ref={toastRef} />
            </div>
        </Layout>
    );
};

export default RemarkFilter;
